query GetOverlayForRender($slug: String!, $kind: String = "DESKTOP") {
  renderData: StreamToolsGetOverlayForRender(slug: $slug, kind: $kind) {
    overlay {
      overlayId
      eventId
      kind
      name
      width
      height
      defaultElementScale
      liveSceneId
      liveScene {
        sceneId
        name
        sourceVersion
        takenAt
        elements {
          elementKind
          elementId
          x
          y
          z
          scale
          visible
          w
          h
        }
      }
      sceneOrder
      version
      createdAt
      scenes {
        sceneId
        overlayId
        eventId
        name
        version
        createdAt
        elements {
          elementKind
          elementId
          x
          y
          z
          scale
          visible
          w
          h
        }
      }
    }
    polls {
      pollId
      eventId
      name
      broadcasterUserIds
      question
      status
      dedupe
      totalVotes
      closeGraceSeconds
      graceEndsAt
      youtubeCountsPurgedAt
      startedAt
      stoppedAt
      createdAt
      callToActionText
      headingTextColor
      optionsTextColor
      callToActionTextColor
      headingBackground
      optionsBackground
      callToActionBackground
      alternatingOptionBackground
      backgroundImage
      backgroundImageFit
      cornerRadius
      borderWidth
      borderColor
      winnerOutlineColor
      fontKey
      template
      tickerLabel
      ctaSubtext
      tickerTextSize
      tickerBlockWeights
      questionFontSize
      tickerLabelFontSize
      displayTextFontSize
      commandFontSize
      numberFontSize
      callToActionFontSize
      closedTextFontSize
      tickerHeight
      version
      options {
        optionId
        displayText
        command
        voteCount
        voteCountByPlatform { twitch youtube }
        textColor
        progressBarColor
        backgroundColor
      }
    }
    trivias {
      triviaId
      eventId
      name
      broadcasterUserIds
      question
      status
      dedupe
      totalVotes
      hasYouTubeVotes
      hideLiveResults
      showAnswersCounter
      closeGraceSeconds
      closedAt
      graceEndsAt
      revealedAt
      youtubeCountsPurgedAt
      answersIn { twitch youtube }
      startedAt
      stoppedAt
      createdAt
      callToActionText
      headingTextColor
      optionsTextColor
      callToActionTextColor
      headingBackground
      optionsBackground
      callToActionBackground
      alternatingOptionBackground
      backgroundImage
      backgroundImageFit
      cornerRadius
      borderWidth
      borderColor
      winnerOutlineColor
      fontKey
      questionFontSize
      displayTextFontSize
      commandFontSize
      numberFontSize
      callToActionFontSize
      revealTextFontSize
      version
      options {
        optionId
        displayText
        command
        voteCount
        voteCountByPlatform { twitch youtube }
        textColor
        progressBarColor
        isCorrect
        backgroundColor
      }
    }
    tugs {
      tugId
      eventId
      name
      broadcasterUserIds
      question
      status
      dedupe
      totalVotes
      startedAt
      stoppedAt
      createdAt
      questionTextColor
      finalizedText
      finalizedTextColor
      backgroundColor
      chatCommandBackground
      barHeight
      backgroundImage
      backgroundImageFit
      cornerRadius
      borderWidth
      borderColor
      fontKey
      version
      optionA {
        displayText
        command
        voteCount
        voteCountByPlatform { twitch youtube }
        color
        textColor
        imageUrl
      }
      optionB {
        displayText
        command
        voteCount
        voteCountByPlatform { twitch youtube }
        color
        textColor
        imageUrl
      }
    }
    scoreboards {
      boardId
      eventId
      name
      createdAt
      title
      titleTextColor
      dividerColor
      backgroundColor
      backgroundImage
      backgroundImageFit
      cornerRadius
      borderWidth
      borderColor
      fontKey
      version
      competitors {
        competitorId
        boardId
        name
        score
        nameTextColor
        scoreTextColor
        imageUrl
        scoreImageUrl
      }
    }
    giveaways {
      giveawayId
      eventId
      name
      broadcasterUserIds
      entryCommand
      winnerCount
      alternateCount
      excludeBroadcaster
      excludeModerators
      rulesUrl
      sponsorName
      prizeName
      prizeImageUrl
      brandLogoUrl
      brandText
      backgroundImage
      backgroundImageFit
      titleText
      openCtaText
      entrantsLabel
      openFooterText
      upcomingHeadline
      upcomingCtaText
      closedHeadline
      closedSubhead
      closedBody
      closedFooterText
      endedHeadline
      congratsText
      endedFooterText
      rulesLabel
      legalText
      fontKey
      textColor
      background
      borderColor
      borderWidth
      cornerRadius
      winnerOutlineColor
      accentBackground
      accentTextColor
      titleFontKey
      textFontKey
      captionFontKey
      subtitleFontKey
      prizeImageRadius
      prizeImageBorderWidth
      prizeImageBorderColor
      prizeImageWidthPx
      countDividerEnabled
      countDividerColor
      countDividerWidthPx
      brandDividerEnabled
      brandDividerColor
      brandDividerWidthPx
      status
      entrantCount
      startedAt
      closedAt
      publishedAt
      createdAt
      version
      hasDraw
      winners {
        login
        displayName
        rank
        kind
      }
    }
  }
}
